<ngx-check-list
  [(checklist)]="checklist"
  (checklistChange)="checklistChanged($event)"
  [purchaseOrderId]="purchaseOrder?.id"
  [purchaseOrder]="purchaseOrder"
  [allowToSaveChecklist]="true"
  [companyType]="'customer'"
></ngx-check-list>
<div class="d-flex mt-4 p-2 justify-content-center align-items-center position-relative">
  <button class="ml-1 mr-1 button-back" type="button" mat-raised-button matStepperPrevious>Back</button>
  <button class="ml-1 mr-1" type="button" mat-raised-button color="grey" (click)="saveDraft.emit()">
    Save to Draft
  </button>
  <button class="ml-1 mr-1" type="button" mat-raised-button color="primary" matStepperNext [disabled]="isFormDirty">
    Next
  </button>
  <button class="ml-1 mr-1 button-discard" type="button" mat-raised-button color="warn"
          (click)="discard.emit()">
    <i class="fa fa-trash"></i>
    Discard
  </button>
</div>
